import { Button } from "antd";

export const detailsColumn = (openPasswordForm) => [
    {
        title: "Hotel Name",
        dataIndex: "hotel_name",
        key: "hotel_name",
        sorter: () => {},
    },
    {
        title: "Call Status",
        dataIndex: "call_status",
        key: "call_status",
        sorter: () => {},
        filters: [
            {
                text: "Outbound",
                value: 1,
            },
            {
                text: "Inbound",
                value: 2,
            },
            {
                text: "Missed Call",
                value: 3,
            },
        ],
        onFilter: (value, record) => record.call_status === value,
        render: (text) => {
            return text === 1
                ? "Outbound"
                : text === 2
                ? "Inbound"
                : text === 3
                ? "Missed Call"
                : "-";
        },
    },
    {
        title: "Type Of Call",
        dataIndex: "call_start_by",
        key: "call_start_by",
        sorter: () => {},
    },
    {
        title: "Agent",
        dataIndex: "agent_name",
        key: "agent_name",
        sorter: () => {},
    },
    {
        title: "Action",
        dataIndex: "action",
        key: "action",
        sorter: () => {},
    },
    {
        title: "Call Purpose",
        dataIndex: "call_purpose",
        key: "call_purpose",
        sorter: () => {},
    },
    {
        title: "Created At",
        dataIndex: "created_at",
        key: "created_at",
        sorter: () => {},
    },
    {
        title: "Get User Details ",
        render: (text, record) => (
            <Button id={record.id} type="primary" onClick={openPasswordForm}>
                Guest Details
            </Button>
        ),
    },
];

export const callLogColumns = (getHotelWiseData, sortedInfo) => {
    return [
        {
            title: "Hotel Name",
            dataIndex: "hotel_name",
            key: "hotel_name",
            sorter: () => {},
            render: (text, record) => (
                <span
                    onClick={getHotelWiseData}
                    id={record.hotel_id}
                    data-hotelname={text}
                    style={{ color: "#1890ff", cursor: "pointer" }}
                >
                    {text}
                </span>
            ),
            sortOrder:
                sortedInfo.columnKey === "hotel_name" ? sortedInfo.order : null,
        },
        {
            title: "Total Number of PBX Calls",
            dataIndex: "call_logs_count",
            key: "call_logs_count",
            sorter: () => {},
            sortOrder:
                sortedInfo.columnKey === "call_logs_count"
                    ? sortedInfo.order
                    : null,
        },
    ];
};
